import { DEFAULT_PAGINATOR_SIZES, ROLE, WIDTH_NG } from "~/assets/js/constants";
import { createPaginator, isAllowedTo } from "~/assets/js/utils";

export const toSector = (sector) => ({
  id: sector.id,
  name: sector.name,
  instanceId: sector.instanceId,
  count: sector.count,
  agencies: sector.agencies ?? null,
});

export const toSectorList = (sectors) => sectors.map(toSector);

export const toSectorRow = (sector, options) => {
  const { role, i18n, isFederatedView } = options;
  const actions = [];

  actions.push({
    active: false,
    id: "sector-expand",
    icon: "s2-icon-expand-regular",
    label: i18n.t("generic.unfold"),
    loading: false,
  });

  if (isAllowedTo([ROLE.ADMIN, ROLE.SERVICEDESK], role) && !isFederatedView) {
    actions.push({
      active: false,
      id: "sector-edit",
      icon: "s2-icon-pen-regular",
      label: i18n.t("generic.edit"),
      loading: false,
    });
  }

  if (isAllowedTo([ROLE.ADMIN, ROLE.SERVICEDESK], role) && !isFederatedView && sector.count === 0) {
    actions.push({
      active: false,
      id: "sector-delete",
      icon: "s2-icon-trash-regular",
      label: i18n.t("generic.delete"),
      loading: false,
    });
  }

  return {
    ...toSector(sector),
    actions,
    columns: [
      { data: { label: sector.name }, id: "name", type: "text" },
      { data: { label: `${sector.count}` }, id: "count", type: "text" },
    ],
  };
};

export const toSectorTable = (sectors, options) => {
  const { i18n, role, isFederatedView } = options;
  const paginator = createPaginator(sectors, i18n, DEFAULT_PAGINATOR_SIZES);

  return {
    paginator,
    sizes: [WIDTH_NG["2XL"], WIDTH_NG.MD],
    headers: [
      { id: "name", label: i18n.t("sectors.headers.name"), sortable: true },
      { id: "count", label: i18n.t("agencies.headers.agencies"), sortable: true },
    ],
    main: "name",
    rows: sectors.collection.map((sector) => toSectorRow(sector, { i18n, role, isFederatedView })),
  };
};

export const toSectorOptions = (sectors) =>
  sectors.map((sector) => ({ id: sector.id, label: sector.name }));
